import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";

import { withRouter } from "react-router-dom";
import { EditUserPass } from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",

      passWord: "",
      passwordHelper: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {}

  handleSave = () => {
    EditUserPass(this.props.match.params.userId, {
      newPassword: this.state.passWord,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای ویرایش شدن رمز عبور");
        } else if (response.status === 200) {
          toast.success("رمز عبور با موفقیت ویرایش شد");
          this.props.history.push("/main/users");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "passWord":
        this.setState({ passWord: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({
            passwordHelper: "لطفا رمزعبور  را وارد کنید",
          });
        } else {
          this.setState({ passwordHelper: "" });
        }

        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component='h1' variant='h4' align='center'>
              ویرایش رمز عبور
            </Typography>

            <React.Fragment>
              <form className={classes.container} noValidate autoComplete='off'>
                <Grid container spacing={3}>
                  <Grid xs={12} sm={4} align='center'>
                    <TextField
                      InputLabelProps={
                        this.state.passWord.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.passWord.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      error={this.state.passwordHelper.length !== 0}
                      helperText={this.state.passwordHelper}
                      onChange={this.onchange}
                      id='passWord'
                      type='password'
                      label='رمز عبور جدید'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.passWord}
                      margin='normal'
                    />
                  </Grid>

                  <Grid item xs={12} align='center'>
                    <Button
                      variant='contained'
                      color='primary'
                      disabled={
                        this.state.loading ||
                        this.state.passwordHelper.length !== 0 ||
                        this.state.passWord.length === 0
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id='message-id'> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(User));
